<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>{{ $store.state.LanguageText[301] }}</v-card-title>
            <v-card-text>
              <p>{{ $store.state.LanguageText[311] }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Error404",

  created() {
    document.title = this.$store.state.LanguageText[301] + " - " + this.$store.state.Config.WebTitle + " : " + this.$store.state.Config.WebSubTitle
    setTimeout(() => {
      this.$router.push("/")
    }, 3000)
  }
}
</script>